import { render, staticRenderFns } from "./ManagerCaption.vue?vue&type=template&id=203395f4&scoped=true&"
import script from "./ManagerCaption.vue?vue&type=script&lang=js&"
export * from "./ManagerCaption.vue?vue&type=script&lang=js&"
import style0 from "./ManagerCaption.vue?vue&type=style&index=0&id=203395f4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203395f4",
  null
  
)

export default component.exports